// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WifiOutlinedSvg from "@ant-design/icons-svg/es/asn/WifiOutlined";
import AntdIcon from '../components/AntdIcon';

var WifiOutlined = function WifiOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WifiOutlinedSvg
  }));
};

WifiOutlined.displayName = 'WifiOutlined';
export default React.forwardRef(WifiOutlined);